import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

/* 引入Antd */
import Antd from "ant-design-vue";
import "ant-design-vue/dist/reset.css";

/* 引入index.less */
import './style/index.less'

const app = createApp(App);

app.use(store);
app.use(router);
app.use(Antd);
app.mount("#app");
